<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="part"><em class="italic">Part I</em></p>
<p class="part-t"><span class="bold">Antipater</span></p>
<a id="page_2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_part01.vue?fc01fb46